import request from './request'
import * as http from '@/libs/http'

/**
 * ユーザのパスワードを更新する
 *
 * @param {Number} uid ユーザID
 * @param {Object} account アカウント情報
 * @returns {Response} レスポンスデータ
 */
export function putUserPassword (uid, account) {
  return request.put(`/users/${uid}/password`, account, {
    validateStatus: (status) => [
      http.OK
    ].includes(status)
  })
}
